module.exports = __webpack_public_path__ + "media/components/assets/img/logo/klm_dutch-3c096c9c57e364ed8f4d3b9d2b39d2c1.png";